import { animated } from "react-spring";
import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  height: calc(100vh - 80px);
  width: 100%;
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
`;
export const MenuWrapper = styled(animated.div)`
  height: 100%;
  overflow-y: auto;
  z-index: 9;
  background: ${(props) => props.theme.primary ?? "#003e85"};
  position: relative;
  width: ${(props) => (props.isCollapsed ? 0 : 310)}px;
  transition: width 0.5s;
  box-shadow: rgba(0, 0, 0, 0.1) 1px 0px 0px 0px;
  ::after {
    content: "";
  }
`;
